import reset from './reset';
import resetMfa from './resetMfa';
import setAuthorized from './setAuthorized';
import setIsMfaRequired from './setIsMfaRequired';

export default {
  reset,
  resetMfa,
  setAuthorized,
  setIsMfaRequired,
};
